import api from "./api";

export const callGetDashboardMetaTemplates = async (page, offset) => {
    try {
        return await api.get(`/templates/dashboard/meta/pageable?page=${page}&offset=${offset}`);
    } catch (error) {
        console.log("Error callGetDashboardMetaTemplates");
    }
};

export const callCreateDashboardMetaTemplate = async (data) => {
    try {
        return await api.post("/templates/dashboard/meta/create", data);
    } catch (error) {
        console.log("Error callCreateDashboardMetaTemplate");
        return error?.response;
    }
};

export const callUpdateDashboardMetaTemplate = async (data) => {
    try {
        return await api.put(`/templates/dashboard/meta/update/${data.templateMetaId}`, data);
    } catch (error) {
        console.log("Error callUpdateDashboardMetaTemplate");
    }
};
